import { render, staticRenderFns } from "./Msg.vue?vue&type=template&id=5c8d4df6"
import script from "./Msg.vue?vue&type=script&lang=ts"
export * from "./Msg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c8d4df6')) {
      api.createRecord('5c8d4df6', component.options)
    } else {
      api.reload('5c8d4df6', component.options)
    }
    module.hot.accept("./Msg.vue?vue&type=template&id=5c8d4df6", function () {
      api.rerender('5c8d4df6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Msg.vue"
export default component.exports